/**
 * Triviální ochrana proti botům, kteří nepoužívají javascipt.
 * Principem je duplikovat hodnotu meše a poslat ji POSTem.
 * @param dom
 */
let registerCleveroMash = (dom) => {
    dom.querySelectorAll("input[data-mash]").forEach((input) => {
        input.value = input.dataset.mash + input.dataset.mash
    })
}

EventBus.getInstance().addEventListener('onForm', (event) => registerCleveroMash(event.detail.dom))
registerCleveroMash(document)
